import { api } from './api';

export const mediaService = {
    /**
     * Download media via the authenticated proxy endpoint.
     * Uses api.ts which automatically attaches the Bearer token.
     */
    downloadMedia: async (mediaId: number | string, type: 'image' | 'video' = 'image'): Promise<Blob> => {
        const mediaType = type === 'video' ? 'videos' : 'images';
        const response = await api.get<Blob>(`/download/${mediaType}/${mediaId}/proxy`, {
            responseType: 'blob',
        });
        return response.data;
    },

    /**
     * Download from an external URL (e.g. S3 presigned URLs).
     * Uses fetch intentionally since external URLs don't need auth headers.
     */
    downloadFromUrl: async (url: string): Promise<Blob> => {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Download failed');
        return response.blob();
    },
};
